import { getPlatform, loadqwebchannel } from './Api.utils';

let isLoadExternal = false;
export function loadExternal(_window) {
    try {
        if (isLoadExternal) {
            return;
        }
        isLoadExternal = true;

        _window.externalDispatchFun = function (module, func, param, callback) {
            try {
                return DispatchFun([module, func, param], callback);
            } catch (e) {
                // console.log(e, 'e')
                try {
                    return dispatchFun([module, func, param], callback);
                } catch (error) {
                    // throw error;
                }
            }
        };

        function dispatchFun(args, callback) {
            let result = window.external.dispatchFun(args[0], args[1], args[2]);
            callback && callback(result);
            return result;
        }
        function DispatchFun(args, callback) {
            const { platform, asyncCall } = getPlatform();
            console.log(platform, asyncCall);
            switch (platform) {
                case 'Phantom': {
                    let result = window.external.DispatchFun(
                        args[0],
                        args[1],
                        args[2]
                    );
                    callback && callback(result);
                    return result;
                }
                case 'Linux PDF Editor': {
                    console.log('Linux PDF Editor', asyncCall);
                    if (asyncCall) {
                        if (window.external) {
                            window.external.DispatchFun(
                                args[0],
                                args[1],
                                args[2],
                                function (result) {
                                    callback && callback(result);
                                    //_this.onHandleResult(result, method, resolve, onEvent);
                                    //resolve(result);
                                }
                            );
                        } else {
                            loadqwebchannel(() => {
                                window.external.DispatchFun(
                                    args[0],
                                    args[1],
                                    args[2],
                                    function (result) {
                                        // !!this.isDebug && console.log('loadqwebchannel finish init');
                                        console.log(
                                            'yes  we  init  the  window.external'
                                        );
                                        callback && callback(result);
                                        //_this.onHandleResult(result, method, resolve, onEvent);
                                    }
                                );
                            });
                        }
                    } else {
                        let result = window.external.DispatchFun(
                            args[0],
                            args[1],
                            args[2]
                        );
                        callback && callback(result);
                        return result;
                    }
                }
                case 'ios': {
                    if (asyncCall) {
                        let id = 'r' + Math.random().toString(32).substr(2);
                        window[id] = function (resultValue) {
                            delete window[id];
                            callback && callback(resultValue);
                        };
                        return window.webkit.messageHandlers.DispatchFun.postMessage(
                            [args[0], args[1], args[2], id]
                        );
                    } else {
                        let result = window.external.DispatchFun(
                            args[0],
                            args[1],
                            args[2]
                        );
                        callback && callback(result);
                        return result;
                    }
                }
                default: {
                    throw 'unknow platform：' + platform;
                }
            }
        }

        let _alert = alert;

        _window.notify = function (msg) {
            /*let div = document.createElement('div');
      div.style = 'z-index: 100000; color: red; font-size: 50px; position: fixed; top: 0; left: 0;';
      let body = document.getElementsByTagName('body')[0];
      body.appendChild(div);*/
            try {
                //div.innerHTML = '1';
                window.external.notify(msg);
                //div.innerHTML = '2';
            } catch (e) {
                // div.innerHTML = '3';
                _alert(msg);
                //div.innerHTML = '4';
            }
        };
    } catch (e) {
        console.log(e);
    }
}
